module.exports = __webpack_public_path__ + "img/contact_icon_1.17746c6e.png";